import { Injectable } from '@angular/core';
import { MapSetting } from '../settings/map.settings';
import { MapModel } from '../models/map.model';
import { map } from 'rxjs/operators';
import { Observable, defer } from 'rxjs';
import { HttpCssClient } from '../shared/http-request.interceptor';

@Injectable({
  providedIn: 'root'
})
export class MapsService {

  constructor(private http: HttpCssClient) {
  }

  public getMapByProduct(id: number): Observable<MapModel> {
    let uri = MapSetting.MAP_ENDPOINT;
    uri = uri.replace(':id', id.toString());
    return this.http.get(uri).pipe(map(response => {
      const body = response;
      const cache = {};
      body.repeatStops = [];
      body.listStops = [];
      body.icons = [];
      body.routes.map(r => {
          r.stoppingPlaces.map((stop) => {
          stop.colours = [];
          stop.colours.push(r.color);
          body.listStops.push(stop);
          if (cache[stop.id]) {
            body.repeatStops.push(stop.id);
          } else {
            cache[stop.id] = true;
          }
        });
      });
      return body;
    }));
  }
}
